import { SubscriptionVariantFreightOptions } from "@cappelendamm/e-commerce-services";
import { FreightCheckoutPart } from "@/checkout/Sections/FreightSection/types";

export const getDefaultFreightValues = (
  freight: SubscriptionVariantFreightOptions,
): FreightCheckoutPart => ({
  freight: {
    initial: freight.initial.map((freight, index) => ({
      ...freight,
      selected: index === 0,
    })),
    recurring: freight.recurring.map((freight, index) => ({
      ...freight,
      selected: index === 0,
    })),
  },
  companyFreightType: null,
});
